module.exports = __webpack_public_path__ + "static/media/2_r_spas_78.85_90.28.5850b343.png";